import { FC } from 'react'
import styled from 'styled-components'

interface IFProps {
  tooltipType: 'myScore' | 'average' | false
  value: number
}

const SpredScoreInfoTableColumnsMobile: FC<IFProps> = ({
  tooltipType,
  value,
}) => {
  return (
    <StyledWrapper data-tooltip-type={tooltipType}>
      {value}
      {tooltipType && (
        <span
          role="tooltip"
          className="tooltip"
          data-tooltip-type={tooltipType}
        >
          {tooltipType === 'myScore' ? '나의 점수' : '전체 평균 점수'}
        </span>
      )}
    </StyledWrapper>
  )
}

export default SpredScoreInfoTableColumnsMobile

const StyledWrapper = styled.div`
  position: relative;
  padding: 14px 0px;
  width: 100%;
  font-size: 16px;
  font-weight: normal;
  letter-spacing: -0.64px;
  text-align: center;
  color: #333;

  > .tooltip {
    height: 23px;
    position: absolute;
    border-radius: 6px;
    display: block;
    z-index: 20;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: -0.48px;
    line-height: 15px;
    text-align: center;
    color: #fff;
    padding: 3px 8px;
    background-color: #666666;
    transform: translate(-50%, -100%);
    left: 50%;
    top: 10%;
    box-shadow: 1px 2px 4px 0 rgba(102, 102, 102, 0.16);

    &[data-tooltip-type='myScore'] {
      width: 70px;
      color: #ffdf11;
      z-index: 30;
    }

    &[data-tooltip-type='average'] {
      width: 90px;
      color: #ffffff;
    }

    &::after {
      border-color: #666666 transparent;
      border-style: solid;
      border-width: 8px 6px 0px 6.5px;
      margin-left: -5px;
      content: '';
      display: block;
      left: 50%;
      position: absolute;
      bottom: -6.5px;
      width: 0;
      z-index: 1;
    }
    &::before {
      border-color: #666666 transparent;
      border-style: solid;
      border-width: 8px 6px 0px 6.5px;
      margin-left: -5px;
      content: '';
      display: block;
      left: 50%;
      position: absolute;
      bottom: -8px;
      width: 0;
      z-index: 0;
    }
  }

  &[data-tooltip-type='myScore'] {
    background-color: #edf9ff;
  }

  &[data-tooltip-type='average'] {
    background-color: #f8fdff;
  }
`
